import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Calendar, Clock, ArrowRight } from 'lucide-react';

export default function BlogIndex() {
  const articles = [
    {
      slug: 'creatine-gummies-vs-powder-cost',
      title: 'Creatine Gummies vs Powder: The Real Cost of Convenience in the UK (2025 Price Analysis)',
      description: 'A comprehensive breakdown of why UK consumers are spending £600+ more per year on gummy supplements - and what you can do about it.',
      date: 'January 26, 2025',
      readTime: '8 min read',
      category: 'Cost Analysis'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-blue-50 to-purple-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex justify-between items-center">
            <Link to="/" className="flex items-center space-x-2">
              <div className="text-2xl font-bold text-green-600">🍬</div>
              <h1 className="text-2xl font-bold text-gray-900">Gummy Truth UK</h1>
            </Link>
            <nav className="flex items-center space-x-6">
              <Link to="/" className="text-sm font-medium text-gray-700 hover:text-gray-900">
                Home
              </Link>
              <Link to="/guide" className="text-sm font-medium text-gray-700 hover:text-gray-900">
                Guide
              </Link>
            </nav>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Hero Section */}
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-gray-900 mb-4">
            The Gummy Truth Blog
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Honest, data-driven analysis of supplement costs in the UK market
          </p>
        </div>

        {/* Articles Grid */}
        <div className="space-y-8">
          {articles.map((article) => (
            <Card key={article.slug} className="border-2 hover:border-green-400 transition shadow-lg hover:shadow-xl">
              <CardHeader>
                <div className="flex items-center space-x-2 text-sm text-gray-500 mb-2">
                  <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full font-medium">
                    {article.category}
                  </span>
                  <div className="flex items-center space-x-1">
                    <Calendar className="h-4 w-4" />
                    <span>{article.date}</span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <Clock className="h-4 w-4" />
                    <span>{article.readTime}</span>
                  </div>
                </div>
                <CardTitle className="text-3xl mb-3">
                  <Link 
                    to={`/blog/${article.slug}`}
                    className="hover:text-green-600 transition"
                  >
                    {article.title}
                  </Link>
                </CardTitle>
                <CardDescription className="text-lg">
                  {article.description}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <Link 
                  to={`/blog/${article.slug}`}
                  className="inline-flex items-center space-x-2 text-green-600 hover:text-green-700 font-semibold"
                >
                  <span>Read Full Article</span>
                  <ArrowRight className="h-5 w-5" />
                </Link>
              </CardContent>
            </Card>
          ))}
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-white border-t mt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="text-center space-y-4">
            <p className="text-sm text-gray-900">
              <strong>Gummy Truth UK © 2025</strong>
            </p>
            <div className="flex justify-center space-x-6 text-sm">
              <Link to="/privacy" className="text-blue-600 hover:underline">
                Privacy Policy
              </Link>
              <Link to="/methodology" className="text-blue-600 hover:underline">
                Methodology
              </Link>
              <Link to="/" className="text-blue-600 hover:underline">
                Calculator
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
